import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  FilaWorkflow, TipoSolicitud, WorkflowsService, mensajeDeError,
} from 'src/app/services/workflows/workflows.service';
import { fecha } from '../workflows.dominio';

/**
 * «Workflows» — la lista. Un renglón por tipo de solicitud, con la versión que rige y el borrador si
 * lo hay. Maqueta aprobada por Juan el 2026-09-28 (https://claude.ai/artifact/QdLk1bxQP74dcBXzaXzmur).
 */
@Component({
  selector: 'app-workflows-lista',
  templateUrl: './workflows-lista.component.html',
  styleUrls: ['./workflows-lista.component.css'],
})
export class WorkflowsListaComponent implements OnInit {
  cargando = true;
  error = '';
  filas: FilaWorkflow[] = [];
  tipos: TipoSolicitud[] = [];
  puedeConfigurar = false;
  tipoNuevo = '';
  creando = false;
  fecha = fecha;

  constructor(private _wf: WorkflowsService, private router: Router) { }

  ngOnInit(): void { this.cargar(); }

  cargar = async (): Promise<void> => {
    this.cargando = true;
    this.error = '';
    try {
      const [filas, tipos, yo] = await Promise.all([this._wf.listar(), this._wf.tipos(), this._wf.yo()]);
      this.filas = filas || [];
      this.tipos = tipos || [];
      this.puedeConfigurar = !!yo?.puede_configurar;
    } catch (e: any) {
      this.filas = [];
      this.error = mensajeDeError(e, 'No se pudieron traer los workflows. Intenta de nuevo en un momento.');
    } finally {
      this.cargando = false;
    }
  };

  /** Los tipos que todavía no tienen workflow: son los únicos con los que se puede crear uno. */
  get tiposSinWorkflow(): TipoSolicitud[] {
    return this.tipos.filter((t) => !this.filas.some((f) => f.tipo_solicitud === t.codigo));
  }

  abrir(f: FilaWorkflow): void {
    const id = f.publicado?._id || f.borrador?._id;
    if (id) this.router.navigate(['/console/workflows', id]);
  }

  crear = async (): Promise<void> => {
    if (!this.tipoNuevo) return;
    this.creando = true;
    this.error = '';
    try {
      const w = await this._wf.abrirBorrador(this.tipoNuevo);
      this.router.navigate(['/console/workflows', w._id]);
    } catch (e: any) {
      this.error = mensajeDeError(e, 'No se pudo crear el workflow.');
    } finally {
      this.creando = false;
    }
  };
}
